import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  organization: Yup.number().notOneOf([0], 'Şirket zorunludur'),
  reconciliation_date: Yup.string().required('Mutabakat tarihi zorunludur.'),
  total_debt: Yup.number().required('Toplam borç zorunludur.'),
  due_debt: Yup.number().required('Vadesi geçmiş zorunludur.'),
});

export default validationSchema;
